import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/design-system";
import { DocumentViewer } from "@/components/ui/document-workspace";
import { siteEquipmentApi } from "@/lib/api/oprema";
import { errorMessage } from "@/lib/api";

export function EquipmentPhotoLink({
  id,
  label,
}: {
  id: string;
  label: string;
}) {
  const [preview, setPreview] = useState<{ url: string; mime: string } | null>(
    null,
  );
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const url = useRef<string | null>(null);
  const controller = useRef<AbortController | null>(null);
  useEffect(
    () => () => {
      controller.current?.abort();
      if (url.current) URL.revokeObjectURL(url.current);
    },
    [id],
  );
  return (
    <>
      <Button
        variant="outline"
        disabled={busy}
        onClick={() => {
          setBusy(true);
          setError("");
          const request = new AbortController();
          controller.current = request;
          void siteEquipmentApi
            .photo(id, request.signal)
            .then((blob) => {
              if (request.signal.aborted) return;
              if (url.current) URL.revokeObjectURL(url.current);
              url.current = URL.createObjectURL(blob);
              setPreview({ url: url.current, mime: blob.type || "image/jpeg" });
            })
            .catch((cause) => {
              if (!request.signal.aborted)
                setError(errorMessage(cause, "Fotka nije dostupna."));
            })
            .finally(() => {
              if (!request.signal.aborted) setBusy(false);
            });
        }}
      >
        Fotka: {label}
      </Button>
      {error && <p role="alert">{error}</p>}
      {preview && (
        <Dialog
          title={`Fotka: ${label}`}
          onClose={() => {
            if (url.current) URL.revokeObjectURL(url.current);
            url.current = null;
            setPreview(null);
          }}
        >
          <DocumentViewer title={label} url={preview.url} mime={preview.mime} />
        </Dialog>
      )}
    </>
  );
}
